import React, { ReactElement, useEffect, useState } from 'react'

import Contract, { ContractCreationFields, ContractMutableFields } from '../../../model/contract'
import Employee from '../../../model/employee'
import { ContractReducer } from '../../../reducers/contracts'
import { visibleComponentDidUpdate } from '../../../utils/component-utils'
import { formatAPIDate } from '../../../utils/date-utils'
import { getValidFrom } from '../../../utils/employment-utils'
import { formatError } from '../../../utils/error-utils'
import { t } from '../../../utils/translation-utils'
import Alert from '../../elements/alert'
import Card from '../../elements/card'
import Subtitle from '../../elements/Subtitle'
import ExtraTaxPercentageModalForm, { ExtraTaxPercentageResult } from './ExtraTaxPercentageModalForm'

type Props = {
  visible: boolean
  employee: Employee
  contract: Contract
  contracts: ContractReducer

  updateContract: (contract: ContractMutableFields) => void
  addContract: (contract: ContractCreationFields) => void
}

export default function ExtraTaxPercentageModal(props: Props): ReactElement | null {
  const [error, setError] = useState<Error | null>(null)

  const { visible, contracts } = props

  useEffect(() => {
    visibleComponentDidUpdate(visible, contracts.error, error, setError)
  }, [visible, contracts, error])

  const handleSubmit = (values: ExtraTaxPercentageResult) => {
    const contract = { ...props.contract, extraTaxPercentage: values.extraTaxPercentage }
    const { validFrom, canUpdate } = getValidFrom(props.employee, contract)
    if (canUpdate) {
      props.updateContract(contract)
    } else {
      contract.validFrom = formatAPIDate(validFrom)
      props.addContract(contract)
    }
  }

  return (
    <Card>
      <Subtitle>{t('tax_card.tab.increase_percentage.title')}</Subtitle>
      <p>{t('tax_card.tab.increase_percentage.intro')}</p>
      <p>&nbsp;</p>
      {error && <Alert message={formatError(error)} type="error" showIcon />}
      <ExtraTaxPercentageModalForm contract={props.contract} contracts={props.contracts} onSubmit={handleSubmit} />
    </Card>
  )
}
